module.exports = __webpack_public_path__ + "img/flightdecklogosimple.3e3697ac.svg";